"use client";

import { useEffect } from "react";

import { getTabSessionId } from "@repo/ui/lib/tabSessionId";

/**
 * Syncs tab_session_id from sessionStorage to a cookie
 * This allows server-side middleware to read the tab session ID
 */
export function TabSessionSync() {
  useEffect(() => {
    const syncCookie = () => {
      const tabSessionId = getTabSessionId();

      if (tabSessionId) {
        document.cookie = `tab_session_id=${tabSessionId}; path=/; SameSite=Lax`;
      } else {
        document.cookie = "tab_session_id=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
      }
    };

    const handleSessionInitialized = () => syncCookie();
    const handleStorage = (event: StorageEvent) => {
      if (event.key === "tab_session_id") {
        syncCookie();
      }
    };

    syncCookie();
    window.addEventListener("session-initialized", handleSessionInitialized);
    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener("session-initialized", handleSessionInitialized);
      window.removeEventListener("storage", handleStorage);
    };
  }, []);

  return null;
}
